module.exports = __webpack_public_path__ + "img/Logo.85483981.svg";